const ServicesCard = ({ services }: { services: any[] }) => {
    return (
      <div>
        {services.map((service, index) => (
          <div key={index} className="flex flex-col bg-white shadow-lg border border-slate-200 p-5 rounded-lg my-6 w-100 mx-auto">
            <div className="flex flex-col justify-center items-center">
              <div className="m-2.5 overflow-hidden rounded-md h-80 flex justify-center items-center">
                {service.img && <img alt="" src={service.img} className="h-80 w-auto" />}
              </div>
              <h1 className="text-2xl">{service.title}</h1>
              {service.description && <p className="text-lg">{service.description}</p>}
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default ServicesCard;